import { lazy } from "react";
const monthReportForm = lazy(() =>
  import("../view/salesMonth/monthReportForm/MonthReportForm")
);
const salesReportForm = lazy(() =>
  import("../view/salesMonth/salesReportForm/SalesReportForm")
);
const salesMonth = [
  {
    path: "/salesMonth/monthReportForm",
    component: monthReportForm,
    id:"monthReportForm"
  },
  {
    path: "/salesMonth/salesReportForm",
    component: salesReportForm,
    id:"salesReportForm"
  }
];
export default salesMonth;